import type { QcFinding } from '@/types';

/**
 * A stable, client-derived ID for a QC finding. Findings don't have DB rows,
 * so we hash {claim_number, category, message} — stable enough to survive a
 * page refresh within the same QC pass, and guaranteed to change if the LLM
 * produces a fresh finding set (which is the right behaviour: re-running QC
 * resets the reviewed state).
 */
export function findingId(f: QcFinding): string {
  const raw = `${f.claim_number}::${f.category}::${f.message}`;
  // DJB2-style rolling hash — small, deterministic, no deps. Collisions across
  // a single matter's findings (usually ≤ 30) are essentially impossible.
  let h = 5381;
  for (let i = 0; i < raw.length; i++) {
    h = ((h << 5) + h + raw.charCodeAt(i)) | 0;
  }
  return `f_${(h >>> 0).toString(36)}`;
}
